import React, { Component } from 'react';
import { Button, Card, Col, Form, message, Row, Transfer } from 'antd';
import { browserHistory } from 'react-router';

import { goBack } from '@comm/BackBtn';
import { queryCustomField, queryCustomView, querySaveCustomView } from '@api/crm/crm';

const FormItem = Form.Item;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      targetKeys: [],
      selectedKeys: [],
      fields: [],
      targetKeys2: [],
      selectedKeys2: [],
      fields2: [],
    };
  }

  componentDidMount() {
    this.getCustomField();
    this.getCustomView();
  }

  getCustomField = () => {
    queryCustomField().then(res => {
      if (res.statusCode === 200) {
        const fields = res.data.map(item => {
          return {
            key: item.value,
            value: item.key,
          };
        });
        this.setState({
          fields,
        });
      }
    });
  };

  getCustomView = () => {
    queryCustomView({
      uuid: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        const targetKeys = [];
        const fields2 = [];
        const targetKeys2 = [];
        res.data.map(item => {
          if (!item.field) {
            return null;
          }
          targetKeys.push(item.field);
          fields2.push({
            key: item.field,
            value: item.fieldName,
          });
          if (item.isRequire) {
            targetKeys2.push(item.field);
          }
          return item;
        });
        this.setState({
          targetKeys,
          fields2,
          targetKeys2,
        });
      }
    });
  };

  formatItem = key => {
    const { fields, targetKeys2 } = this.state;
    let filedItem = {};
    let isRequire = 0;
    fields.forEach((item, index) => {
      if (key === item.key) {
        filedItem = fields[index];
      }
    });
    if (targetKeys2.includes(key)) {
      isRequire = 1;
    }
    return {
      field: filedItem.key,
      fieldName: filedItem.value,
      isRequire,
    };
  };

  handleSubmit = () => {
    const { targetKeys } = this.state;

    const config = [];
    targetKeys.forEach(item => {
      config.push(this.formatItem(item));
    });
    const params = {
      uuid: this.props.params.uuid,
      config,
    };
    this.saveCustomView(params);
  };

  saveCustomView = params => {
    querySaveCustomView(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  setFields2 = nextTargetKeys => {
    const { fields } = this.state;
    let fields2 = [];
    nextTargetKeys.forEach(key => {
      fields2 = fields2.concat(
        fields.filter(item => {
          return item.key === key;
        }),
      );
    });
    this.setState({
      fields2,
    });
  };

  handleChange = nextTargetKeys => {
    this.setState({ targetKeys: nextTargetKeys });
    this.setFields2(nextTargetKeys);
  };

  handleSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
    this.setState({
      selectedKeys: [...sourceSelectedKeys, ...targetSelectedKeys],
    });
  };

  handleChange2 = nextTargetKeys => {
    this.setState({ targetKeys2: nextTargetKeys });
  };

  handleSelectChange2 = (sourceSelectedKeys, targetSelectedKeys) => {
    this.setState({
      selectedKeys2: [...sourceSelectedKeys, ...targetSelectedKeys],
    });
  };

  render() {
    const { targetKeys, selectedKeys, fields } = this.state;
    const { targetKeys2, selectedKeys2, fields2 } = this.state;

    return (
      <Card title="设置客户显示">
        <Form>
          <FormItem>
            <p>客户默认的字段：名字/联系人/电话</p>
          </FormItem>
        </Form>
        <FormItem label="设置显示字段">
          <Transfer
            dataSource={fields}
            titles={['主要字段', '显示字段']}
            targetKeys={targetKeys}
            selectedKeys={selectedKeys}
            onChange={this.handleChange}
            onSelectChange={this.handleSelectChange}
            render={item => item.value}
          />
        </FormItem>
        <FormItem label="设置必填字段">
          <Transfer
            dataSource={fields2}
            titles={['显示字段', '必填字段']}
            targetKeys={targetKeys2}
            selectedKeys={selectedKeys2}
            onChange={this.handleChange2}
            onSelectChange={this.handleSelectChange2}
            render={item => item.value}
          />
        </FormItem>
        <Row>
          <Col span={24} style={{ marginBottom: 15, textAlign: 'right' }}>
            <Button
              style={{ marginRight: 10 }}
              type="primary"
              htmlType="submit"
              onClick={this.handleSubmit}
            >
              确定
            </Button>
            <Button onClick={goBack}>取消</Button>
          </Col>
        </Row>
      </Card>
    );
  }
}
export default Form.create({ wrappedComponentRef: true })(Index);



// WEBPACK FOOTER //
// ./src/components/crm/department/PageSetInfo.js